import { DropdownOption, useSearchParamsQuery } from "@finbackoffice/site-core";
import { usePathnameWithLocal } from "hooks";
import ActiveLink from "components/base/active-link/ActiveLink";
import { Svg } from "components/base/svg/Svg";
import { AssetsDirectory } from "@finbackoffice/enums";
import Translate from "components/base/translate/Translate";
import { useParams } from "next/navigation";
import { FC } from "react";
import styles from "./advanced-sidebar-footer.module.sass";

type Props = {
    language: DropdownOption;
};

const AdvancedSidebarLanguage: FC<Props> = ({ language }) => {
    const params = useParams();
    const { pathnameWithoutLocale: path } = usePathnameWithLocal();
    const { query, getQueryString } = useSearchParamsQuery();

    const onLocaleChangeHandler = async (val: string) => {
        const queryString = getQueryString();

        window.location.pathname = `/${val}${path}${queryString ? "?" : ""}${queryString}`;
    };

    return (
        <ActiveLink
            key={language.value}
            forceActive={params.lang === language.value}
            href={{
                pathname: `/${language.value}${path}`,
                query,
            }}
            activeClassName={styles.selected}
            prefetch={false}
            onClick={(e) => {
                e.preventDefault();
                void onLocaleChangeHandler(language.value);
            }}>
            <>
                <Svg
                    src={`/${AssetsDirectory.Common}/${AssetsDirectory.Languages}/${language.value}.svg`}
                    className="svg-region-icon"
                    prefixAppName
                />
                {typeof language.label === "string" && <Translate tid={language.label} />}
            </>
        </ActiveLink>
    );
};

export default AdvancedSidebarLanguage;
